import React from "react";
import cn from 'classnames';
import { Dropdown } from "react-bootstrap";
import { ThreeDotMenu } from "components";
import { IFilter } from "interfaces";
import { UpdatePageModel } from "../UpdatePageModel";
import { Link } from "react-router-dom";
import { getUpdateResultsURL } from "pages/Reports/ReportsModel";

export interface IFilterMenuProps {
    canEdit: boolean,
    className?: string,
    filter: IFilter,
    isGlobalFilters: boolean,
    isNew: boolean,
    menuRef?: React.MutableRefObject<HTMLDivElement>,
    model: UpdatePageModel,
    stageIndex: number,
    onDelete: () => void,
    onDuplicate: () => void,
}

export function FilterMenu({ canEdit, className, filter, isGlobalFilters, isNew, menuRef, model, stageIndex, onDelete, onDuplicate }: IFilterMenuProps) {
    // Build a url to the filter results.
    const resultsURL = getUpdateResultsURL({
        updateId: model.update.id,
        isGlobalFilters: isGlobalFilters,
        stageIndex: stageIndex,
        filterId: filter.id,
    });
    const deleteItem = (
        <Dropdown.Item as="button" onClick={onDelete} className="dropdown-item-danger">
            Delete
        </Dropdown.Item>
    );

    return <ThreeDotMenu ref={menuRef} className={cn('filterMenu', className)}>
        {isNew && deleteItem}
        {!isNew && (<>
            <Link to={resultsURL} className="dropdown-item">
                View affected devices
            </Link>
            {canEdit && <>
                <Dropdown.Item as="button" onClick={onDuplicate}>
                    Duplicate
                </Dropdown.Item>
                <Dropdown.Divider />
                {deleteItem}
            </>}
        </>)}
    </ThreeDotMenu>;
}